import type { FC, ReactNode } from "react";
import type { IconName } from "@fortawesome/fontawesome-common-types";
import { Icon } from "@onshopfront/components";

export const PartnerIconWithText: FC<{
    icon: IconName;
    children: ReactNode;
}> = ({ icon, children }) => {
    return (
        <div className="flex gap-2">
            <div className="w-6 text-center">
                <Icon icon={[ "fal", icon ]} className="text-xs leading-5!" />
            </div>
            <span className="text-[var(--color-text-secondary)]">{children}</span>
        </div>
    );
};
